var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebox",class:_vm.value ? 'active' : ''},[_c('div',{staticClass:"sidebox-close-btn",on:{"click":_vm.handleClose}},[_c('i',{staticClass:"el-icon-d-arrow-right"})]),_vm._v(" "),_c('div',{staticClass:"sidebox-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e7084b0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebox/Sidebox.vue
// module id = 1343
// module chunks = 137